const templateMoneyControl = (index: number, args: any) => {
  let theData = args[columnsOfForecast[index].field];
  return (
    <div>
      {theData !== '' ? <div>${theData?.toLocaleString()}</div> : <div></div>}
    </div>
  );
};
export const columns = [
  {
    field: 'id',
    headerText: 'Forecast Run Code',
    textAlign: 'Left',
    isPrimaryKey: true,
    width: '10%',
    allowEditing: false,
  },
  {
    field: 'description',
    headerText: 'Description',
    textAlign: 'Left',
    width: '15%',
    allowEditing: true,
  },
  {
    field: 'forecast_date',
    headerText: 'Forecast Date',
    textAlign: 'Left',
    width: '15%',
    allowEditing: false,
    format: 'dd/MM/yyyy',
    type: 'date',
  },
  {
    field: 'forecast_amount',
    headerText: 'Forecast Amount',
    width: '15%',
    allowEditing: false,
    textAlign: 'Left',
    format: 'C2',
  },
  {
    field: 'last_amount',
    headerText: 'Diff from last Forecast',
    width: '15%',
    allowEditing: false,
    format: 'C2',
    textAlign: 'Left',
  },
];
export const columnsOfForecast = [
  {
    field: 'p_id',
    headerText: 'Proccess Id',
    textAlign: 'Left',
    width: '10%',
    visible: false,
  },
  {
    field: 'pid',
    headerText: 'Parent',
    textAlign: 'Left',
    width: '15%',
  },
  {
    field: 'plant_no',
    headerText: 'Asset No',
    textAlign: 'Left',
    width: '15%',
  },
  {
    field: 'plant_desc',
    headerText: 'Description',
    textAlign: 'Left',
    width: '10%',
  },
  {
    field: 'plt_pm_task_no',
    headerText: 'Task No',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'plt_pm_task_text',
    headerText: 'PM Description',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Jan',
    headerText: 'Jan',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 6),
  },
  {
    field: 'Feb',
    headerText: 'Feb',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 7),
  },
  {
    field: 'Mar',
    headerText: 'Mar',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 8),
  },
  {
    field: 'Apr',
    headerText: 'Apr',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 9),
  },
  {
    field: 'May',
    headerText: 'May',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 10),
  },
  {
    field: 'Jun',
    headerText: 'Jun',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 11),
  },
  {
    field: 'Jul',
    headerText: 'Jul',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 12),
  },
  {
    field: 'Aug',
    headerText: 'Aug',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 13),
  },
  {
    field: 'Sept',
    headerText: 'Sept',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 14),
  },
  {
    field: 'Oct',
    headerText: 'Oct',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 15),
  },
  {
    field: 'Nov',
    headerText: 'Nov',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 16),
  },
  {
    field: 'Dec',
    headerText: 'Dec',
    width: '15%',
    textAlign: 'Left',
    format: 'C2',
    template: templateMoneyControl.bind(this, 17),
  },
  {
    field: 'total',
    headerText: 'total',
    width: '15%',
    format: 'C2',
    textAlign: 'Left',
  },
];
export const columnsOfForecastAggregate = [
  {
    field: 'Jan',
    headerText: 'Jan',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Feb',
    headerText: 'Feb',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Mar',
    headerText: 'Mar',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Apr',
    headerText: 'Apr',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'May',
    headerText: 'May',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Jun',
    headerText: 'Jun',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Jul',
    headerText: 'Jul',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Aug',
    headerText: 'Aug',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Sept',
    headerText: 'Sept',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Oct',
    headerText: 'Oct',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Nov',
    headerText: 'Nov',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'Dec',
    headerText: 'Dec',
    width: '15%',
    textAlign: 'Left',
  },
  {
    field: 'total',
    headerText: 'total',
    width: '15%',
    format: 'C2',
    textAlign: 'Left',
  },
];
